import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueSlider from 'vue-slider-component'
import VueIntro from 'vue-introjs'
import './plugins/element.js'
import 'vue-slider-component/theme/default.css';

Vue.use(VueIntro)
Vue.component('VueSlider', VueSlider)

export const bus = new Vue();
Vue.config.productionTip = false;

export const config = {
    apiUrlOrigin: process.env.VUE_APP_API_URL_ORIGIN,
}

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
